import React from "react";
import { RootState } from "StoreTypes";
import { connect } from "react-redux";
import { AlertItem } from "../../types";
import styles from "./styles.module.scss";
import DataTable from "../../components/DataTable";
import { ALERTS_FORM_COLUMNS } from "./constants";
import { fetchAlerts } from "../../services/reports/selectors";

export interface Props {
  alerts: AlertItem[];
}

const AlertsViewer = ({ alerts }: Props) => {
  return (
    <div>
      <div className={styles.title}>
        <h2>Alerts</h2>
      </div>
      <div id={"alerts-table"}>
        <div className={styles.table}>
          <DataTable
            tableData={alerts}
            columns={ALERTS_FORM_COLUMNS}
            csvFileName={""}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  alerts: fetchAlerts(state),
});
export default connect(mapStateToProps)(AlertsViewer);
